import { RouteEntity } from "@ots-frontend/ots-data";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseRouteSelectProps = BaseEntitySelectProps<RouteEntity>;

export const BaseRouteSelect = (props: BaseRouteSelectProps) => {
  return <BaseEntitySelect {...props} />;
};
